import styled from '@emotion/styled'

import { Color } from '../../../../enums/color'
import { rwd } from '../../../../utils/rwd'
import { AspectRatio } from '../../types'
import { LIMIT_CANVAS_WIDTH_CLASS_NAME } from './constants/limitCanvasWidthClassName'

interface PdfReactWrapperProps {
  aspectRatio?: AspectRatio
  isError?: boolean
  height?: number
}

export const PdfReactWrapper = styled.div<PdfReactWrapperProps>`
  display: flex;
  justify-content: center;
  width: 100%;
  height: ${({ height }) => (height ? height + 'px' : 'auto')};
  background-color: ${Color.White};
  color: ${Color.Grey500};
  aspect-ratio: ${({ aspectRatio }) => aspectRatio || 'auto'};

  .${LIMIT_CANVAS_WIDTH_CLASS_NAME} {
    canvas {
      max-width: 200%;
    }
  }

  ${({ isError }) =>
    isError &&
    `
      padding-bottom: 100%;
      position: relative;
      color: ${Color.Red700};

      ${rwd.equalOrLessThan('large')} {
        padding-bottom: 45%;
      }
    `};
`

export const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

/* PDFs are rendered with scale x2 or x4 to ensure good quality on zoom, scaling down with transform corrects this difference */
export const ScaleWrapper = styled.div<{ scaleFromCenter?: boolean }>`
  transform: scale(0.5);
  transform-origin: left top;
`
